import { AVButtonRoundedFull } from "../../components/common/AVButtons";
import * as AV from "../../AVCore/AVCore";
import { HStack, Text, VStack, Pressable, Box, Button } from "native-base";
import React, { useEffect, useState } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import {
  setUser,
  setEntityToken,
  setEntitydata,
} from "../../Redux/Actions/userActions";
import { Person } from "../../AVCore/Person";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import inform from "../../assets/images/inform.png";
import AVInputtext from "../../components/AVInputtext";
import { Loc } from "../../App/Loc";
import validator from "validator";
import _ from "lodash";
import CustomToast from "../../Hooks/useCustomToast";
import AddandEditLinks from "../common/AddandEditLinks";
import AVConfirmLinkPopup from "../../components/common/AVConfirmLinkPopup";

function RenderUserInfo({
  data,
  isOwner,
  userID,
  isMobile,
  setEditProfile,
  setUserInfo,
  editProfile,
  profile,
  setProfile,
  isCreateDependents,
  setIsCreateDependents,
  setIsMyPage,
  setIsEventPage,
  setIsTeamsPage,
  setIsPhotoPage,
  setIsDocumentPage,
  setisMembersPage,
  setIsDependentsPage,
  setIsPetPage,
  setisGuardianspage,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isProfileSaving, setIsProfileSaving] = useState(false);
  const [Name, setName] = useState("");
  const [editdata, setEditData] = useState<any>();
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const entitydatalist: any = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  const entityToken = useSelector(
    (state: RootStateOrAny) => state?.user.entityToken,
  );
  const [isUpdate, setIsUpdate] = useState(false);
  const [fullname, setfullname] = useState("");
  const [email, setEmail] = useState("");
  const [url, setUrl] = useState("");
  const [intro, setIntro] = useState<any>();
  const [isValidUrl, setIsValidUrl] = useState(false);
  const [message, setMessage] = useState("");
  const [addLinkPopup, setAddLinkPopup] = useState(false);
  const [linkList, setLinksList] = useState<any>([]);
  const [clickedUrl, setClickedUrl] = useState("");
  const [showConfirmLinkPopup, setShowConfirmLinkPopup] = useState(false);
  const [address, setAddress] = useState<any>({
    normalized: null,
    city: null,
    region: null,
    zip: null,
    lat: null,
    lng: null,
  });
  const urlRegex =
    /^(https?|ftp):\/\/[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})?(:\d+)?(\/\S*)?$/;

  //Save profile
  const handleSaveProfile = async (e) => {
    if (url?.trim()?.length > 0) {
      if (!urlRegex.test(url)) {
        let clientError = { message: Loc.currentLang.menu.invalidExternalLink };
        CustomToast({ clientError });
        return;
      }
    }

    if (!isCreateDependents) {
      try {
        let fk = AV.AVEntity.getFk(data);
        if (fk?.id) {
          e.preventDefault();
          setIsProfileSaving(true);
          const p: any = await AV.Person.get(AV.AVEntity.getFk(data));
          p.address ??= {};
          p.address = address;
          p.address.city = "";
          //p.address.normalized = "";
          p.address.region = "";
          p.address.placeId = null;
          p.name = fullname;
          p.Preferences = {
            IsPrivate: false,
          };
          p.links = linkList;
          p.profile ??= {};
          p.profile.text = intro;
          let res = await AV.AVEntity.save(p);
          setIsProfileSaving(false);

          if (res) {
            setUserInfo(res);
            if (currentUser?.id === res?.id) dispatch(setUser(res));
            let index = entitydatalist?.findIndex((x) => x?.id === res?.id);
            if (index !== -1) {
              entitydatalist[index] = res;
              dispatch(setEntitydata(entitydatalist));
            }
            setUserInfo(entitydatalist[index]);
            setEditProfile(false);
          }

          if (p?.status === "NewUser") {
            //localStorage.setItem("isNewUser", "true");
            localStorage.setItem("highlightCreateNew", "true");

            //// Member:
            //localStorage.setItem("showTeamMemberTour", "true");
            //localStorage.setItem("showClubMemberTour", "true");
            //localStorage.setItem("showEliteClubMemberTour", "true");
            //localStorage.setItem("showSchoolStaffTour", "true");
            //localStorage.setItem("showGroupMemberTour", "true");
            //localStorage.setItem("showOrganizationEmployeeTour", "true");
            //localStorage.setItem("showNeighborhoodNeighborsTour", "true");
            //localStorage.setItem("showCommunityMemberTour", "true");

            //// Player
            //localStorage.setItem("showTeamSeasonPlayerTour", "true");
            //localStorage.setItem("showClubTermMemberTour", "true");
            //localStorage.setItem("showSchoolYearStudentTour", "true");
            //localStorage.setItem("showClassStudentTour", "true");
            //localStorage.setItem("showGradClassStudentTour", "true");
            //localStorage.setItem("showPerformancePlayerTour", "true");
          }

          let followList: AV.IFollowList | null = null;

          try {
            followList = await AV.AVEntity.getMyFollowers(data);
          } catch (error) {
            setIsProfileSaving(false);
            console.error("Failed to fetch followers:", error);
          }

          let userData = [
            ...(followList?.followers ?? []),
            ...(data?.wards ?? []),
            ...(data?.follows ?? []),
            ...(data?.members ?? []),
            ...(data?.guardians ?? []),
          ];

          // Remove duplicates
          userData = _.uniqBy(userData, "id");

          for (const user of userData) {
            try {
              // Find parent entity
              let userEntity =
                entitydatalist?.find((x) => x?.id === user.id) ?? null;

              // Fetch entity if not exists
              if (!userEntity) {
                userEntity = await AV.AVEntity.get(user);
                entitydatalist.push(userEntity);
              }

              // Check links
              const result = await AV.AVEntity.checkLinks(userEntity, data);

              // Update entity list
              const userIndex = entitydatalist.findIndex(
                (x) => x?.id === user.id,
              );

              if (userIndex !== -1) {
                entitydatalist[userIndex] = result;
              }
            } catch (error) {
              console.error(`Error while processing user ${user?.id}:`, error);
            }
          }

          // Redux update
          dispatch(setEntitydata([...entitydatalist]));

          setIsUpdate(true);
          if (entityToken?.type) {
            entityToken?.type == "Person" || entityToken?.type == "Pet"
              ? navigate(`/profile/${entityToken?.id}/${entityToken?.region}`, {
                  state: {
                    user: {
                      id: entityToken?.id,
                      pk: entityToken?.pk,
                      region: entityToken?.region,
                      type: entityToken?.type,
                      name: entityToken?.title,
                    },
                  },
                })
              : entityToken?.type == "LeagueTeam"
                ? navigate(
                    `/season/${entityToken?.id}/${entityToken?.region}`,
                    {
                      state: { isCreate: false, team: entityToken },
                    },
                  )
                : entityToken?.type == "Team"
                  ? navigate(
                      `/teams/${entityToken?.id}/${entityToken?.region}`,
                      {
                        state: { isCreate: false, team: entityToken },
                      },
                    )
                  : navigate(
                      `/organizations/${entityToken?.id}/${entityToken?.region}/${entityToken?.type}`,
                      {
                        state: {
                          isCreate: false,
                          orgType: entityToken?.type,
                          org: entityToken,
                        },
                      },
                    );
          } else {
            navigate(`/profile/${res?.id}/${res?.region}`, {
              state: { user: Person.getLink(res) },
            });

            dispatch(setEntityToken([]));
          }

          handlePageClick();
          setIsProfileSaving(false);
          setIsCreateDependents(false);
          //dispatch(setEntityToken([]));
        }
      } catch (error) {
        handlePageClick();
        setIsProfileSaving(false);
        setIsCreateDependents(false);
        console.error("Error saving person profile:", error);
      }
    } else {
      e.preventDefault();
      setIsProfileSaving(true);

      try {
        var personEntity: any = {
          address: address,
          name: fullname,
          email: email,
          type: "Person",
          preferences: {
            IsPrivate: false,
          },
          links: linkList,
          profile: {
            ...(personEntity?.profile ?? profile),
            text: intro,
          },
        };

        personEntity = await AV.AVEntity.save(personEntity);

        const addDependent: AV.IPerson = await AV.Person.addDependent({
          id: personEntity?.id,
          type: personEntity?.type,
          name: fullname,
          email: email,
          phone: "",
        });

        const person = await AV.Person.getSelf(true);
        if (person) {
          setUserInfo(person);
          if (currentUser?.id === person?.id) dispatch(setUser(person));
          let index = entitydatalist?.findIndex((x) => x?.id === person?.id);
          if (index !== -1) {
            entitydatalist[index] = person;
            dispatch(setEntitydata(entitydatalist));
          }
          setUserInfo(entitydatalist[index]);
        }

        handlePageClick();
        dispatch(setEntityToken([]));
        setIsProfileSaving(false);
        setIsCreateDependents(false);
      } catch (error) {
        handlePageClick();
        dispatch(setEntityToken([]));
        setIsProfileSaving(false);
        setIsCreateDependents(false);
        console.error("Error saving dependent profile:", error);
      }
    }
  };

  const handlePageClick = () => {
    setEditProfile(false);
    setIsCreateDependents(false);
    setIsMyPage(true);
    setIsEventPage(false);
    setIsTeamsPage(false);
    setIsPhotoPage(false);
    setIsDocumentPage(false);
    setisMembersPage(false);
    setIsDependentsPage(false);
    setIsPetPage(false);
    setisGuardianspage(false);
  };

  useEffect(() => {
    if (currentUser?.status === "NewUser" && data?.id === currentUser?.id)
      setEditProfile(true);
    setIsUpdate(true);
    async function getUpdatedAddress() {
      if (data?.length !== 0) {
        const p = data; //const p = await AV.Person.get(AV.AVEntity.getFk(data));
        setAddress(p?.address);
        setName(p?.name);
        setfullname(p?.name);
        setIntro(p?.profile?.text);
        setUrl(p?.url);
        setEditData(p);
      }
    }

    setIsUpdate(false);

    if (!isCreateDependents) {
      getUpdatedAddress();
    }
  }, [isUpdate, data]);

  useEffect(() => {
    if (!isCreateDependents) {
      setAddress(currentUser?.address);
      setName(currentUser?.name);
      setfullname(currentUser?.name);
      setIntro(currentUser?.profile?.text);
      setUrl(currentUser?.url);
      setLinksList(currentUser?.links);
      setEditData(currentUser);
    }

    setIsEventPage(false);
    setIsTeamsPage(false);
    setIsPhotoPage(false);
    setIsDocumentPage(false);
    setisMembersPage(false);
    setIsDependentsPage(false);
    setIsPetPage(false);
    setisGuardianspage(false);
  }, [editProfile]);

  useEffect(() => {
    const initialAddress = {
      normalized: null,
      city: null,
      region: null,
      zip: null,
      lat: null,
      lng: null,
    };
    setAddress(currentUser?.address ?? initialAddress);
    setName("");
    setfullname("");
    setEmail("");
    setIntro("");
    setUrl("");
    setLinksList("");
    setEditData([]);

    //setEditProfile(false);
    setIsEventPage(false);
    setIsTeamsPage(false);
    setIsPhotoPage(false);
    setIsDocumentPage(false);
    setisMembersPage(false);
    setIsDependentsPage(false);
    setIsPetPage(false);
    setisGuardianspage(false);
  }, [isCreateDependents]);

  return (
    <VStack width={"100%"}>
      <>
        {(editProfile || isCreateDependents) && isOwner && (
          <HStack>
            <>
              <VStack
                width={"90%"}
                justifyContent={"center"}
                margin={"auto"}
                marginBottom={3}
              >
                <HStack
                  justifyContent={isMobile ? "space-between" : "flex-end"}
                  alignItems={"center"}
                  space={5}
                  marginBottom={"10px"}
                  marginTop={"-27px"}
                >
                  {data?.status !== "NewUser" && (
                    <Button
                      background={"#EEEEEE"}
                      width={isMobile ? "100px" : "120px"}
                      height={"40px"}
                      left={isMobile ? "120px" : ""}
                      rounded="full"
                      isDisabled={isProfileSaving}
                      onPress={() => {
                        setEditProfile(false);
                        setIsCreateDependents(false);
                        setIsMyPage(true);
                        setIsEventPage(false);
                        setIsTeamsPage(false);
                        setIsPhotoPage(false);
                        setIsDocumentPage(false);
                        setisMembersPage(false);
                        setIsDependentsPage(false);
                        setIsPetPage(false);
                        setisGuardianspage(false);
                      }}
                    >
                      <Text color={"rgba(0, 0, 0, 0.50)"} fontWeight={500}>
                        {Loc.currentLang.menu.cancel}
                      </Text>
                    </Button>
                  )}

                  <Button
                    bgColor={"#32AE78"}
                    width={isMobile ? "100px" : "120px"}
                    height={"40px"}
                    rounded="full"
                    isLoading={isProfileSaving}
                    isDisabled={
                      fullname?.trim()?.length === 0 ||
                      address?.zip?.trim()?.length === 0 ||
                      address?.zip === undefined
                    }
                    onPress={handleSaveProfile}
                  >
                    <Text color={"#ffffff"} fontWeight={500}>
                      {data?.status !== "NewUser" && data?.status !== undefined
                        ? Loc.currentLang.menu.update
                        : Loc.currentLang.menu.save}
                    </Text>
                  </Button>
                </HStack>

                <HStack>
                  <img src={inform} style={{ width: "20px", height: "20px" }} />
                  <Text style={{ marginBottom: "10px", marginLeft: "10px" }}>
                    {isCreateDependents
                      ? Loc.currentLang.helpText.person.dependentTab
                      : Loc.currentLang.helpText.editProfile}
                  </Text>
                </HStack>

                <VStack space={3} width={"100%"}>
                  <HStack space={3} width={"100%"}>
                    {(editProfile || isCreateDependents) && (
                      <Box flex={1} width={"100%"}>
                        <AVInputtext
                          type={"text"}
                          label={Loc.currentLang.menu.name}
                          onChange={(e) => setfullname(e.target.value)}
                          value={fullname}
                          height={"15px"}
                          maxLength={50}
                          defaultValue={undefined}
                          width={undefined}
                          minRows={undefined}
                          multiline={undefined}
                          size={undefined}
                          placeholder={undefined}
                        />
                      </Box>
                    )}
                  </HStack>

                  <HStack>
                    <Box width={"100%"}>
                      <AVInputtext
                        type={"text"}
                        label={
                          Loc.currentLang.placeholderText.personalDescription
                        }
                        onChange={(e) => setIntro(e.target.value)}
                        value={intro}
                        multiline={true}
                        minRows="3"
                        maxLength={250}
                        size="medium"
                        width={"100%"}
                        defaultValue={undefined}
                        height={undefined}
                        placeholder={undefined}
                      />
                    </Box>
                  </HStack>

                  <HStack>
                    <Box width={"100%"}>
                      <AVInputtext
                        type={"text"}
                        label={Loc.currentLang.placeholderText.streetAddress}
                        onChange={(e) =>
                          setAddress({
                            ...address,
                            normalized: e.target?.value,
                          })
                        }
                        value={address?.normalized}
                        height={"15px"}
                        width={"100%"}
                        defaultValue={undefined}
                        minRows={undefined}
                        multiline={undefined}
                        maxLength={undefined}
                        size={undefined}
                        placeholder={undefined}
                      />
                    </Box>
                  </HStack>

                  <HStack space={3} width={"100%"}>
                    <Box flex={1} width={"100%"}>
                      <AVInputtext
                        type={"text"}
                        label={Loc.currentLang.placeholderText.city}
                        onChange={(e) =>
                          setAddress({ ...address, city: e.target?.value })
                        }
                        value={address?.city}
                        height={"15px"}
                        defaultValue={undefined}
                        width={undefined}
                        minRows={undefined}
                        multiline={undefined}
                        maxLength={undefined}
                        size={undefined}
                        placeholder={undefined}
                      />
                    </Box>

                    <Box flex={1} width={"100%"}>
                      <AVInputtext
                        type={"text"}
                        label={Loc.currentLang.placeholderText.state}
                        onChange={(e) =>
                          setAddress({ ...address, region: e.target?.value })
                        }
                        value={address?.region}
                        height={"15px"}
                        defaultValue={undefined}
                        width={undefined}
                        minRows={undefined}
                        multiline={undefined}
                        maxLength={undefined}
                        size={undefined}
                        placeholder={undefined}
                      />
                    </Box>

                    <Box flex={1} width={"100%"}>
                      <AVInputtext
                        type={"text"}
                        label={Loc.currentLang.placeholderText.zip}
                        onChange={(e) =>
                          setAddress({ ...address, zip: e.target.value })
                        }
                        value={address?.zip}
                        height={"15px"}
                        defaultValue={undefined}
                        width={undefined}
                        minRows={undefined}
                        multiline={undefined}
                        maxLength={undefined}
                        size={undefined}
                        placeholder={undefined}
                      />
                    </Box>
                  </HStack>

                  <HStack>
                    {/*Profile Url*/}
                    <Pressable
                      width={"100%"}
                      zIndex={-3}
                      onPress={() => {
                        setAddLinkPopup(true);
                      }}
                    >
                      <HStack>
                        <Text color={"#00A7BC"} fontWeight={500}>
                          +
                        </Text>
                        <Text color={"#00A7BC"} fontWeight={500}>
                          {editProfile && linkList?.length > 0
                            ? Loc.currentLang.menu.editLinks
                            : Loc.currentLang.menu.addLinks}
                        </Text>
                      </HStack>
                    </Pressable>

                    {addLinkPopup && (
                      <AddandEditLinks
                        setAddLinkPopup={setAddLinkPopup}
                        setLinksList={setLinksList}
                        linkList={linkList}
                        isCreate={!editProfile}
                        isCreateEvent={undefined}
                        setClickedUrl={setClickedUrl}
                        setShowConfirmLinkPopup={setShowConfirmLinkPopup}
                      />
                    )}
                  </HStack>
                </VStack>
              </VStack>
            </>
          </HStack>
        )}

        {showConfirmLinkPopup && (
          <AVConfirmLinkPopup
            url={clickedUrl}
            handleCancel={() => setShowConfirmLinkPopup(false)}
          />
        )}
      </>
    </VStack>
  );
}

export default React.memo(RenderUserInfo);
